function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import Icon from '@material-ui/core/Icon';
const useStyles = makeStyles(theme => ({
  list: {
    position: "relative",
    listStyle: "none",
    padding: theme.spacing(.5),
    margin: 0
  },
  item: {
    display: "block",
    minWidth: theme.spacing(20),
    "&[data-variant=text] + [data-variant=outlined]": {
      marginTop: theme.spacing(.5)
    }
  },
  button: {
    borderRadius: 0,
    "&.MuiButton-text": {
      padding: theme.spacing(1),
      justifyContent: "flex-start"
    },
    "&.MuiButton-outlined": {
      padding: theme.spacing(1),
      justifyContent: "center"
    }
  },
  icon: {
    color: "inherit",
    "& + $label": {
      marginLeft: theme.spacing(1)
    }
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: '14px',
    lineHeight: '24px',
    textTransform: 'none',
    letterSpacing: 0
  }
}));

const ListItem = (_ref) => {
  let style = _ref.style,
      value = _ref.value,
      icon = _ref.icon,
      label = _ref.label,
      selected = _ref.selected,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "text" : _ref$variant,
      color = _ref.color,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["style", "value", "icon", "label", "selected", "variant", "color", "onClick"]);

  const classes = useStyles(props);
  return React.createElement("li", {
    className: classes.item,
    "data-variant": variant
  }, React.createElement(Button, {
    className: classes.button,
    "aria-selected": selected,
    variant: variant,
    value: value,
    color: color,
    fullWidth: true,
    onClick: onClick
  }, icon && React.createElement(Icon, {
    className: classes.icon
  }, icon), React.createElement("b", {
    className: classes.label
  }, label)));
};

const List = (_ref2) => {
  let children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["children"]);

  const classes = useStyles(props);
  return React.createElement("ul", {
    className: classes.list
  }, children);
};

const OptionsList = (_ref3) => {
  let cols = _ref3.cols,
      rows = _ref3.rows,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      onSelect = _ref3.onSelect,
      props = _objectWithoutPropertiesLoose(_ref3, ["cols", "rows", "options", "onSelect"]);

  return React.createElement(List, null, options.map((item, index) => React.createElement(ListItem, _extends({}, item, {
    key: index,
    onClick: () => onSelect(item)
  }), item.value)));
};

export default OptionsList;